import React from 'react'
import LtsDropdownUnidade from '../../../components/lottus/lts-dropdown-unidade'
import _ from 'lodash'
import utils, { getMessage } from '../../../utils'
import { Card } from 'primereact/card'
import { icons } from '../../../constants'
import { Button } from 'primereact/button'
import { Divider } from 'primereact/divider'
import MovimentoEstoqueItem from './movimento-estoque-item'
import { RadioButton } from 'primereact/radiobutton'
import LtsLookupProduto from '../../../components/lottus/lts-lookup-produto'
import LtsInputNumber from '../../../components/lottus/lts-input-number'

const inventario = 'inventario'
const transferencia = 'transferencia'
const max = 9999999

export const MovimentoEstoqueForm = (props) => {
  const record = props.record
  const item = props.item
  const messages = props.messages
  const setField = props.setField
  const setItem = props.setItem

  const optionsUnidadeDestino = () => {
    const unidadesOrigem = props.unidades
    return unidadesOrigem.filter((u) => u.id !== _.get(record, 'unidadeOrigem.id', null))
  }

  const renderTipoMovimentoEstoque = () => {
    return (
      <React.Fragment>
        <div className="p-grid form-group">
          <label style={{ marginLeft: '8px', marginBottom: '10px' }}>
            {utils.getMessage(messages, 'movimentoestoque.label.tipo')}
          </label>
        </div>
        <div className="p-grid form-group">
          <div className="p-col-12 p-sm-12 p-md-10 p-lg-8 p-xl-6">
            <RadioButton
              value={inventario}
              name="tipoinventario"
              onChange={(e) => props.setTipoMovimento(e)}
              checked={record.tipo === inventario}
            />
            <label className="label" style={{ marginLeft: '5px' }}>
              {utils.getMessage(messages, 'movimentoestoque.label.inventario')}
            </label>
          </div>
        </div>
        <div className="p-grid form-group">
          <div className="p-col-12 p-sm-12 p-md-10 p-lg-8 p-xl-6">
            <RadioButton
              value={transferencia}
              name="tipotransferencia"
              onChange={(e) => props.setTipoMovimento(e)}
              checked={record.tipo === transferencia}
            />
            <label className="label" style={{ marginLeft: '5px' }}>
              {utils.getMessage(messages, 'movimentoestoque.label.transferencia')}
            </label>
          </div>
        </div>
      </React.Fragment>
    )
  }

  const renderUnidadeOrigem = () => {
    return (
      <div className="p-grid form-group">
        <div className="p-col-12 p-sm-12 p-md-10 p-lg-8 p-xl-6">
          <LtsDropdownUnidade
            name={'unidadeOrigem'}
            label={
              record.tipo === 'inventario'
                ? getMessage(messages, 'movimentoestoque.label.unidade')
                : getMessage(messages, 'movimentoestoque.label.unidadeOrigem')
            }
            value={record.unidadeOrigem}
            onChange={(e) => setField('unidadeOrigem', e)}
            showOptionAll={false}
            disabled={props.disableUnit}
            options={props.unidades}
            forceOptions={true}
          />
        </div>
      </div>
    )
  }

  const renderUnidadeDestino = () => {
    if (record.tipo === inventario) {
      return null
    }
    return (
      <div className="p-grid form-group">
        <div className="p-col-12 p-sm-12 p-md-10 p-lg-8 p-xl-6">
          <LtsDropdownUnidade
            name={'unidadeDestino'}
            label={getMessage(messages, 'movimentoestoque.label.unidadeDestino')}
            value={record.unidadeDestino}
            onChange={(e) => setField('unidadeDestino', e)}
            showOptionAll={false}
            disabled={props.disableUnit}
            options={optionsUnidadeDestino()}
            forceOptions={true}
          />
        </div>
      </div>
    )
  }

  const renderProduto = () => {
    return (
      <div className="p-grid form-group">
        <div className="p-col-12 p-sm-12 p-md-10 p-lg-8 p-xl-6">
          <LtsLookupProduto
            label={getMessage(messages, 'movimentoestoque.label.produto')}
            value={_.get(item, 'produto.descricao', '')}
            oidRecord={_.get(item, 'produto.id', '')}
            history={props.history}
            onChange={(e) => props.setProduto(e)}
            editHidden={true}
          />
        </div>
      </div>
    )
  }

  const renderQuantidade = () => {
    const resolveLabel = () => {
      let label = getMessage(props.messages, 'movimentoestoque.label.quantidade')
      if (record.tipo === transferencia && _.isNumber(props.saldoEstoque)) {
        label = `${label} - máx: ${props.saldoEstoque}`
      }
      return label
    }
    const resolveMax = () => {
      if (record.tipo === inventario) {
        return max
      }
      return props.saldoEstoque
    }
    return (
      <div className="p-grid form-group">
        <div className="p-col-12 p-sm-6 p-md-4 p-lg-3 p-xl-3">
          <LtsInputNumber
            min={max * -1}
            max={resolveMax()}
            value={_.get(item, 'quantidade', 0)}
            onChange={(e) => setItem('quantidade', e)}
            name={'quantidade'}
            label={resolveLabel()}
          />
        </div>
      </div>
    )
  }

  const renderBotaoAdicionar = () => {
    const checkDisabled = () => {
      if (record.tipo === inventario) {
        return (
          !_.get(item, 'produto.oid', null) || !_.get(record, 'unidadeOrigem.id', null) || !_.isNumber(item.quantidade)
        )
      }
      return (
        !_.get(item, 'produto.oid', null) ||
        !_.get(record, 'unidadeOrigem.id', null) ||
        !_.get(record, 'unidadeDestino.id', null) ||
        !_.isNumber(item.quantidade) ||
        props.saldoEstoque <= 0
      )
    }

    return (
      <div className="p-grid form-group">
        <div className="p-col-8 p-sm-3 p-md-2 p-lg-2 p-xl-2">
          <Button
            disabled={checkDisabled()}
            onClick={(e) => props.addItem(item)}
            label={getMessage(props.messages, 'movimentoestoque.label.adicionar')}
            icon={icons.PLUS_ICON}
            className="p-button-success"
          />
        </div>
      </div>
    )
  }

  return (
    <div className="p-grid p-fluid">
      <div className="p-col-12">
        <Card>
          {renderTipoMovimentoEstoque()}
          <Divider />
          {renderUnidadeOrigem()}
          {renderUnidadeDestino()}
          {renderProduto()}
          {renderQuantidade()}
          {renderBotaoAdicionar()}
          <Divider />
          <MovimentoEstoqueItem
            values={props.itens}
            messages={props.messages}
            onClickRemoveItem={props.onClickRemoveItem}
            tipo={record.tipo}
          ></MovimentoEstoqueItem>
        </Card>
      </div>
    </div>
  )
}
